import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormEmployeeReferenceComponent } from './form-employee-reference.component';
import { FormGroupModule } from '../form-group/form-group.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FormEmployeeReferenceComponent
  ],
  imports: [
    CommonModule,
    FormGroupModule,
    ReactiveFormsModule
  ],
  exports: [
    FormEmployeeReferenceComponent
  ]
})
export class FormEmployeeReferenceModule { }
